import { MenuItem, FormControl, IconButton, InputLabel } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { useSearchParams } from 'react-router-dom';
import { FilterWrapper, ValueFormatterContext } from 'shared/ui/filter/filter-wrapper';

export const NotificationsFilter = () => {
  const statusFormatter = ({ value }: ValueFormatterContext) => (value === 'true' ? 'Прочитанные' : 'Новые');

  return (
    <FilterWrapper title="Фильтры уведомлений">
      <FilterWrapper.Item label="Статус" queryKeys="isRead" valueFormatter={statusFormatter}>
        <SelectBool queryParamName='isRead' />
      </FilterWrapper.Item>
    </FilterWrapper>
  );
};

const SelectBool = ({ queryParamName }: {queryParamName: string}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const handleChange = (event: SelectChangeEvent<string>) => {
    const { target: { value } } = event;
  
    setSearchParams(prev => {
      if (value.length > 0) {
        prev.set(queryParamName, `${value}`);
      } else {
        prev.delete(queryParamName);
      }
      return prev;
    }, { replace: true });
  };

  const value = searchParams?.get(queryParamName) ?? '';

  return (
    <FormControl fullWidth>
      <InputLabel id="invoice-status-select-label" sx={{ backgroundColor: 'white', px: 1 }}>
      Статус
      </InputLabel>
      <Select
        labelId="invoice-status-select-label"
        value={value}
        onChange={handleChange}
        variant={'outlined'}
        endAdornment={
          value !== ''  && (
            <IconButton sx = {{ mr: 1.5, height: 24, width:24 }}
              onClick={() => {
                setSearchParams((prev) => {
                  prev.delete(queryParamName);
                  return prev;
                }, { replace: true });
              }}
            >
              <ClearIcon/>
            </IconButton>
          )
        }
      >
        <MenuItem value="false">Новые</MenuItem>
        <MenuItem value="true">Прочитанные</MenuItem>
      </Select>
    </FormControl>
  );
};
